<template>
  <v-container fluid fill-height class="login-container">
    <img class="login-bg" src="@/assets/login__background.png" alt />
    <v-layout align-center justify-center>
      <v-flex xs12 sm8 md4>
        <v-card class="login-form">
          <div class="login-logo">
            <h2>
              Bienvenido a <br />
              BBX Courier
            </h2>
            <img
              src="@/assets/user_login.png"
              alt="logo"
              class="center-block"
            />
          </div>
          <v-card-text>
            <v-form v-model="valid">
              <v-alert
                :value="error"
                color="error"
                icon="mdi-warning"
                outlined
                >{{ msj }}</v-alert
              >
              <v-text-field
                required
                :rules="required"
                class="user-prefix"
                v-model="text1"
                :label="language.user"
                type="email"
                solo
              ></v-text-field>

              <v-text-field
                :rules="required"
                required
                id="password"
                solo
                v-model="text2"
                :label="language.password"
                type="password"
              ></v-text-field>
            </v-form>
            <v-btn
              :disabled="!valid"
              block
              color="primary"
              @click="validateLogin"
              rounded
              class="login-separador-btn"
              >{{ language.login }}</v-btn
            >
            <div class="text-center mt-3">
              <v-btn text color="primary" to="/signup">{{
                language.sign_up
              }}</v-btn>
            </div>

            <div class="text-center mt-3">
              <v-btn color="secondary" text to="/forgetpassword">
                {{ language.forget_your_password }}
              </v-btn>
            </div>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
    <v-snackbar :timeout="2000" v-model="snackbarLogin">
      {{ language.invalid_username_or_password }}
      <v-btn text @click.native="snackbarLogin = false">{{
        language.close
      }}</v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
// import Helpers from "../utils/helpers";
import Server from "../utils/server";
// import Language from "../utils/language";
export default {
  created() {
    console.log(this.language);
  },
  mounted() {
    if (this.login === true) {
      this.$router.push("home");
    }
  },
  data: function() {
    return {
      valid: false,
      text1: "",
      text2: "",
      error: false,
      msj: "",
      required: [(v) => !!v || this.language.the_field_is_required],
      emailRules: [
        (v) => !!v || this.language.the_field_is_required,
        (v) =>
          /^[_a-z0-9-]+(\.[_a-z0-9-]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,4})$/.test(
            v
          ) || this.language.the_email_must_be_valid,
      ],
      snackbarLogin: false,
    };
  },
  computed: {
    login: function() {
      return this.$store.getters.login;
    },
    profile: function() {
      return this.$store.getters.profile;
    },
    language: function() {
      return this.$store.getters.language;
    },
  },
  methods: {
    validateLogin: function() {
      // const _this = this;

      // this.$store.dispatch('login', true)
      // this.$router.push('packages')

      var formData = new FormData();
      formData.append("text1", this.text1);
      formData.append("text2", this.text2);
      formData.append("device", window.MobileApi.device);

      this.$http.post(Server.login, formData).then(
        (response) => {
          console.log(response.body.resultado);
          if (response.body.resultado != 0) {
            this.$store.dispatch("login", true);
            this.$router.push("home");
            window.MobileApi.setSessionId(response.body.resultado);
          } else {
            this.snackbarLogin = true;
          }
        },
        () => {
          this.error = true;
          this.msj = this.language.an_error_has_occurred_try_again_later;
        }
      );

      // Helpers.getJson(Server.login, 'POST', formData, function (json) {
      //   console.log(json.resultado)
      //   if (json.resultado > 0) {
      //     _this.$store.dispatch('login', true)
      //     _this.$router.push('packages')
      //   } else {
      //     _this.snackbarLogin = true
      //   }
      // })
    },
  },
};
</script>

<style lang="sass" scoped>
@import "../assets/css/login.scss"
</style>
